/*
* Copyright (c) 2019 Honeywell International, Inc. All rights reserved.
*
* This file contains trade secrets of Honeywell International, Inc.  No part
*  may be reproduced or transmitted in any form by any means or for any
*  purpose without the express written permission of Honeywell.
*
*/
import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { Language } from '../../../../context-discovery-services/models/language.model';

@Component({
  selector: 'adminapp-upload-language-selector',
  templateUrl: './upload-language-selector.component.html',
  styleUrls: ['./upload-language-selector.component.scss']
})
export class UploadLanguageSelectorComponent {

  @ViewChild('languageSelectionDialog') languageSelectionDialog;
  @ViewChild('languageSelector') languageSelector;
  @Input() languages: Array<Language>;
  @Output() languageSelectionModalEvents = new EventEmitter<any>();

  constructor() { }

  isPrimaryLanguageSelected(): boolean {
    const selectedLanguages: Array<string> = this.languageSelector.getSelectedLanguageCodes();
    return (selectedLanguages && selectedLanguages.length > 0);
  }

  onNextToLanguageSelection(): void {
    this.languageSelectionModalEvents.emit({success: true, data: this.languageSelector.getSelectedLanguageCodes()});
  }

  onCloseLanguageSelection(event): void {
    if ((event.detail && event.detail.confirmed) || (event.target !== this.languageSelectionDialog.nativeElement)) {
      return;
    }
    this.languageSelectionModalEvents.emit({success: false});
  }
}
